import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLinkItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { faBoxOpen, faEllipsisVertical, faTruck, faUserSecret } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@shared/components/ui/button';
import { usePermissions } from '@shared/hooks/usePermissions';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ImpersonateModal, ImpersonateModalRef } from '../../../List/components/modals';
import { Client } from '../../../List/models/Clients';

interface DropdownActionsProps {
  client: Client | undefined;
  onImpersonate?: (userId: number) => void;
}

export const DropdownActions: FC<DropdownActionsProps> = ({ client, onImpersonate }) => {
  const { t } = useTranslation('viewClientModule');
  const { canAccess } = usePermissions();
  const impersonateModalRef = useRef<ImpersonateModalRef>(null);

  // 🎯 Verificar permisos
  const isTenant3PL = canAccess(['tenant_3pl']);
  const canImpersonate = canAccess(['tenant_3pl'], ['iam.impersonation.start']);

  if (!isTenant3PL || !client) {
    return null;
  }

  const handleImpersonateClick = () => {
    impersonateModalRef.current?.open(() => {
      onImpersonate(client.user_id);
    }, client.name);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon">
            <FontAwesomeIcon icon={faEllipsisVertical} className="!w-3 !h-3" />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end" className="w-52 border-card-border">
          <DropdownMenuLinkItem to={`/clients/${client.id}/rules`}>
            <FontAwesomeIcon icon={faTruck} className="mr-2 w-3.5" />
            {t('actions.viewRules')}
          </DropdownMenuLinkItem>

          <DropdownMenuLinkItem
            to={`/clients/${client.id}/packaging-rulesets`}
            data-testid="view-packaging-rules-from-detail-action"
          >
            <FontAwesomeIcon icon={faBoxOpen} className="mr-2 w-3.5" />
            {t('actions.viewPackagingRules')}
          </DropdownMenuLinkItem>

          {canImpersonate && onImpersonate && (
            <DropdownMenuItem onClick={handleImpersonateClick} className="whitespace-nowrap">
              <FontAwesomeIcon icon={faUserSecret} className="mr-2 w-3.5" />
              {t('actions.impersonate')}
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <ImpersonateModal ref={impersonateModalRef} />
    </>
  );
};
